export default __webpack_public_path__ + "static/media/divider_corner.4631be6b.svg";